import React, { Component } from 'react';
import { Row, Col, Panel } from 'react-bootstrap';
import IncentivePerformance from '../common/store-performances/incentive-performance';
import './style.css';
class RetailerIncentivePerformances extends Component {

  state = {
    open: false
  };

  toggleContent = () => {
    this.setState({ open: !this.state.open });
  };

  componentDidMount() {
    const { current_user } = this.props;
    if (current_user.attributes['user-group'] === 'staff') {
      this.setState({ open: true });
    }
  }

  render() {
    const {
      correct_to_date, customer_number, name, incentives, outlet
    } = this.props;

    const { open } = this.state;

    let date = correct_to_date.split('/');
    date[2] = date[2].substring(2,4);
    date = date.join('/');

    return (
      <div>
        <div className="incentive-performances">
          <Panel
            header={(
              <div onClick={this.toggleContent}>
                <Row>
                  <Col xs={10} className={'incentive-performance-panel-customer-number'}>
                    {name + ''} {customer_number}
                  </Col>
                  <Col xs={2} className={"panel-toggle"}>
                    <span className={`glyphicon ${open ? "glyphicon-minus" : "glyphicon-plus"}`}></span>
                  </Col>
                </Row>
              </div>
            )}
          >
            {open && incentives.map((incentive, index) => {
                return (
                  <IncentivePerformance key={index} incentive={incentive} date={date} outlet_id={outlet} />
                );
            })}
          </Panel>
        </div>
      </div>
    )
  }
}

export default RetailerIncentivePerformances;



// WEBPACK FOOTER //
// ./src/components/store-performance/retailer-incentive-performances.jsx